

















import Vue from "vue";
import { Component, Prop, Mixins } from "vue-property-decorator";
import TagHelper from "../../mixins/TagHelper";

@Component
export default class Tags extends Mixins(TagHelper) {
  // props
  @Prop(Array) readonly dataSelectedTags: string[] | undefined;
  @Prop(String) readonly dataType: string | undefined;
  // data
  selectedTags: string[] = this.dataSelectedTags || [];
  // computed
  get tagList() {
    return this.$store.state.tagList;
  }
  // hooks
  created() {
    this.$store.commit("fetchTagList");
  }
  // methods
  toggle(tagName: string) {
    const index = this.selectedTags.indexOf(tagName);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
    } else {
      this.selectedTags.push(tagName);
    }
    this.$emit("update:selectedTags", this.selectedTags);
  }
}
